import Link from 'next/link';

import type { SanityProductUpdateCallToAction } from '@lib/sanity/types';

export type CompleteCallToAction = { label: string; url: string };

/** The Studio asks for both halves, but an API write can leave one out. */
export const toCompleteCallToAction = (
  callToAction: SanityProductUpdateCallToAction | null | undefined
): CompleteCallToAction | null => {
  const label = callToAction?.label?.trim();
  const url = callToAction?.url?.trim();
  return label && url ? { label, url } : null;
};

export const CallToActionLink = ({
  callToAction,
  className
}: {
  callToAction: CompleteCallToAction;
  className: string;
}) =>
  callToAction.url.startsWith('/') ? (
    <Link href={callToAction.url} className={className}>
      {callToAction.label}
    </Link>
  ) : (
    <a href={callToAction.url} className={className}>
      {callToAction.label}
    </a>
  );
